import { isString } from 'lodash';

// Any "/" followed by nothing or not followed by "/" or "\".
const REG_EXP = /^\/([^/\\]|$)/;

export default function isRelativeUrl(url: any = '') {
  if (!url || !isString(url)) {
    return false;
  }

  return REG_EXP.test(url);
}
